import React from "react";

// A single overview KPI card: icon in a colored rounded square, the value,
// an optional trend badge ("↑12.5%") and a "vs <range>" subtext line.
// Both Dashboard.jsx (clinic) and NewDashboard1.jsx (normal) map their own
// tile-config arrays through this so the visual style stays identical while
// each dashboard keeps its own data/keys. Kept compact/short (fixed-height
// icon row + a single value line) so many tiles fit in one row.
const KpiTileCard = ({
  icon,
  label,
  value,
  color = "#037FE8",
  bgColor,
  trendPct, // number (can be negative) or null/undefined to hide the badge
  vsLabel, // e.g. "vs Jul 05 - Jul 11"
  onClick,
  active = false, // true when this tile is the one currently filtering Today's Schedule
}) => {
  const hasTrend = trendPct !== null && trendPct !== undefined && !Number.isNaN(trendPct);
  const isUp = hasTrend && trendPct >= 0;
  const iconBg = bgColor || `${color}1A`;

  return (
    <div
      className="kpi-tile-card"
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        borderRadius: "10px",
        border: `1px solid ${active ? color : "#E3EBF8"}`,
        background: active ? `${color}0D` : "#fff",
        padding: "10px 12px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        minWidth: 0,
        height: "100%",
        boxSizing: "border-box",
        transition: "border-color 0.15s ease, background 0.15s ease",
      }}
    >
      <div
        style={{
          width: 30,
          height: 30,
          borderRadius: "8px",
          background: iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          fontSize: "14px",
        }}
      >
        {icon}
      </div>

      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: "11px", color: "#6B7280", marginBottom: "1px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {label}
        </div>
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px", flexWrap: "nowrap", minWidth: 0 }}>
          <span
            style={{
              fontSize: "16px",
              fontWeight: 700,
              color: "#111827",
              lineHeight: 1.1,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: 0,
            }}
          >
            {value ?? "-"}
          </span>
          {hasTrend && (
            <span
              style={{
                fontSize: "10.5px",
                fontWeight: 600,
                color: isUp ? "#16A34A" : "#DC2626",
                whiteSpace: "nowrap",
                flexShrink: 0,
              }}
            >
              {isUp ? "↑" : "↓"}{Math.abs(trendPct).toFixed(1)}%
            </span>
          )}
        </div>
        {/* Always render this line (even blank) so every tile reserves the
            same 3-line height whether or not it has a trend/vsLabel — keeps
            tiles like "Crew Utilization" (no weekKey) the same height as
            the rest instead of collapsing shorter. */}
        <div style={{ fontSize: "9.5px", color: "#9CA3AF", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", minHeight: "12px" }}>
          {vsLabel || " "}
        </div>
      </div>
    </div>
  );
};

export default KpiTileCard;
